import { useEffect } from 'react';

export default function useScrollReveal(pageRef) {
    useEffect(() => {
        let observer;
        const rafId = requestAnimationFrame(() => {
            const root = pageRef.current;
            if (!root) return;
            
            observer = new IntersectionObserver(
                (entries) => {
                    entries.forEach((entry) => {
                        if (entry.isIntersecting) {
                            entry.target.classList.add('revealed');
                            observer.unobserve(entry.target);
                        }
                    });
                },
                { threshold: 0.08, rootMargin: '0px 0px -30px 0px' }
            );
            
            root.querySelectorAll('.sprint-reveal, .sprint-reveal-left, .sprint-reveal-right, .sprint-reveal-scale, .cro-reveal, .cro-reveal-left, .cro-reveal-right, .cro-reveal-scale').forEach((el) => {
                observer.observe(el);
            });
        });

        return () => {
            cancelAnimationFrame(rafId);
            if (observer) observer.disconnect();
        };
    }, [pageRef]);
}
